var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.visible,
        "before-close": _vm.handleClose,
        width: "520px"
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _vm.endpoint && _vm.endpoint.origin !== "RISOLTO"
        ? [
            _c("el-alert", {
              attrs: {
                title: _vm.$t("warning"),
                type: "info",
                description: _vm.$t("ContactDialog.are_you_sure"),
                "show-icon": ""
              }
            }),
            _vm._v(" "),
            _c(
              "el-checkbox",
              {
                staticClass: "mt-5",
                model: {
                  value: _vm.form.copy_to_risolto,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "copy_to_risolto", $$v)
                  },
                  expression: "form.copy_to_risolto"
                }
              },
              [
                _vm._v(
                  " " + _vm._s(_vm.$t("ContactDialog.copy_to_risolto")) + " "
                )
              ]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "mt-20",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "120px" }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("ChannelEndpointDialog.channel") } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: _vm.$t("ChannelEndpointDialog.channel"),
                    disabled: _vm.disabled
                  },
                  on: { change: _vm.handleChannelChange },
                  model: {
                    value: _vm.form.channel,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "channel", $$v)
                    },
                    expression: "form.channel"
                  }
                },
                _vm._l(_vm.channels, function(item) {
                  return _c("el-option", {
                    key: item,
                    attrs: { label: _vm.$translate.channel(item), value: item }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.channel == "EMAIL"
            ? [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("ChannelEndpointDialog.email"),
                      prop: "email"
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder: _vm.$t("ChannelEndpointDialog.email"),
                        disabled: _vm.disabled
                      },
                      model: {
                        value: _vm.form.email,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "email", $$v)
                        },
                        expression: "form.email"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.form.channel == "PHONE"
            ? [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("ChannelEndpointDialog.phone"),
                      prop: "phone"
                    }
                  },
                  [
                    _c("vue-tel-input", {
                      attrs: { mode: "international", disabled: _vm.disabled },
                      on: { validate: _vm.handlePhoneValidation },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "arrow-icon",
                            fn: function() {
                              return [_c("span", [_vm._v("▼")])]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        2680791877
                      ),
                      model: {
                        value: _vm.form.telephone_number,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "telephone_number", $$v)
                        },
                        expression: "form.telephone_number"
                      }
                    }),
                    _vm._v(" "),
                    _vm.phoneInvalid
                      ? _c("p", { staticClass: "error" }, [
                          _vm._v(
                            _vm._s(_vm.$t("validator.action.sms.to.is_invalid"))
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.form.channel == "MAIL"
            ? [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("ChannelEndpointDialog.company_name")
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: { disabled: _vm.disabled },
                      model: {
                        value: _vm.form.company_name,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "company_name", $$v)
                        },
                        expression: "form.company_name"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("ChannelEndpointDialog.street"),
                      prop: "street_name"
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: { disabled: _vm.disabled },
                      model: {
                        value: _vm.form.street_name,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "street_name", $$v)
                        },
                        expression: "form.street_name"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("ChannelEndpointDialog.street_number"),
                      prop: "street_number"
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: { disabled: _vm.disabled },
                      model: {
                        value: _vm.form.street_number,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "street_number", $$v)
                        },
                        expression: "form.street_number"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: _vm.$t("ChannelEndpointDialog.post_box") }
                  },
                  [
                    _c("el-input", {
                      attrs: { disabled: _vm.disabled },
                      model: {
                        value: _vm.form.post_box,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "post_box", $$v)
                        },
                        expression: "form.post_box"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("ChannelEndpointDialog.city") } },
                  [
                    _c("el-input", {
                      attrs: { disabled: _vm.disabled },
                      model: {
                        value: _vm.form.city,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "city", $$v)
                        },
                        expression: "form.city"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("ChannelEndpointDialog.zip"),
                      prop: "zip_code"
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: { disabled: _vm.disabled },
                      model: {
                        value: _vm.form.zip_code,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "zip_code", $$v)
                        },
                        expression: "form.zip_code"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("ChannelEndpointDialog.country"),
                      prop: "iso_country_code"
                    }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { size: "mini", disabled: _vm.disabled },
                        model: {
                          value: _vm.form.iso_country_code,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "iso_country_code", $$v)
                          },
                          expression: "form.iso_country_code"
                        }
                      },
                      _vm._l(_vm.countries, function(country, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: country.name, value: country.code }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("ChannelEndpointDialog.locale") } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: _vm.$t("ChannelEndpointDialog.locale"),
                    disabled: _vm.disabled
                  },
                  model: {
                    value: _vm.form.language,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "language", $$v)
                    },
                    expression: "form.language"
                  }
                },
                _vm._l(_vm.languages, function(item) {
                  return _c("el-option", {
                    key: item,
                    attrs: { label: _vm.$translate.language(item), value: item }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.form.invoicing,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "invoicing", $$v)
                    },
                    expression: "form.invoicing"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("ChannelEndpointDialog.invoicing")))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.channel == "EMAIL" && _vm.form.invoicing
            ? _c(
                "el-form-item",
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "small" },
                      model: {
                        value: _vm.form.invoicing_type,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "invoicing_type", $$v)
                        },
                        expression: "form.invoicing_type"
                      }
                    },
                    [
                      _c("el-radio-button", { attrs: { label: "TO" } }, [
                        _vm._v("TO")
                      ]),
                      _vm._v(" "),
                      _c("el-radio-button", { attrs: { label: "CC" } }, [
                        _vm._v("CC")
                      ]),
                      _vm._v(" "),
                      _c("el-radio-button", { attrs: { label: "BCC" } }, [
                        _vm._v("BCC")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.form.dunning,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "dunning", $$v)
                    },
                    expression: "form.dunning"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("ChannelEndpointDialog.dunning")))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.channel == "EMAIL" && _vm.form.dunning
            ? _c(
                "el-form-item",
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "small" },
                      model: {
                        value: _vm.form.dunning_type,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "dunning_type", $$v)
                        },
                        expression: "form.dunning_type"
                      }
                    },
                    [
                      _c("el-radio-button", { attrs: { label: "TO" } }, [
                        _vm._v("TO")
                      ]),
                      _vm._v(" "),
                      _c("el-radio-button", { attrs: { label: "CC" } }, [
                        _vm._v("CC")
                      ]),
                      _vm._v(" "),
                      _c("el-radio-button", { attrs: { label: "BCC" } }, [
                        _vm._v("BCC")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v(_vm._s(_vm.$t("shared.Cancel")))
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { loading: _vm.loading, type: "primary" },
              on: { click: _vm.handleFormSubmit }
            },
            [_vm._v(_vm._s(_vm.$t("shared.Confirm")))]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }